import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

interface AppTile {
  name: string;
  image: string;
  route?: string;
  description?: string;
}

@Component({
  selector: 'app-apps',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './apps.html',
  styleUrl: './apps.css',
})
export class Apps {
  expandedModules = false;
  expandedProducts = false;

  readonly coreModules: AppTile[] = [
    { name: 'Human Resource',  image: 'images/webps/hr.svg',            route: '/hr',           description: 'Manage employee attendance & payroll' },
    { name: 'CRM',             image: 'images/webps/crm.svg',           route: '/crm',          description: 'Track leads and build stronger relationships' },
    { name: 'Manufacturing',   image: 'images/webps/manufacturing.svg', route: '/manufacturing', description: 'Plan production and manage operations' },
    { name: 'Inventory',       image: 'images/webps/inventory.svg',     route: '/inventory',    description: 'Track stock levels and items' },
    { name: 'Sales',           image: 'images/webps/sales.svg',         route: '/sales',        description: 'Manage orders and customer sales' },
    { name: 'Procurement',     image: 'images/webps/procurement.svg',   route: '/procurement',  description: 'Streamline purchases and vendor management' },
    { name: 'Accounting',      image: 'images/webps/accounting.svg',    route: '/accounting',   description: 'Manage ledgers, invoices & financial reports' },
  ];

  readonly applications: AppTile[] = [
    { name: 'Point Of Sale',   image: 'images/mobilizers/pos.png',    route: '/hr', description: 'Fast & easy billing solution' },
    { name: 'Schools',         image: 'images/mobilizers/school.png', route: '/hr', description: 'Manage school activities and records' },
    { name: 'HIMS',            image: 'images/mobilizers/hims.png',   route: '/hr', description: 'Hospital & patient management' },
  ];

  get visibleCoreModules(): AppTile[] {
    return this.expandedModules ? this.coreModules : this.coreModules.slice(0, 3);
  }

  get visibleApplications(): AppTile[] {
    return this.expandedProducts ? this.applications : this.applications.slice(0, 12);
  }

  toggleModules(): void {
    this.expandedModules = !this.expandedModules;
  }

  toggleProducts(): void {
    this.expandedProducts = !this.expandedProducts;
  }

  trackByTile(index: number, tile: AppTile): string {
    return `${tile.name}-${index}`;
  }
}
